import { MapPinX } from 'lucide-react';
import React from 'react';

export const EmptyMapView = React.memo(() => {
  return (
    <div className='emptyState tw-h-full'>
      <div className='bgImg' />
      <p className='!tw-text-[1.4rem] !tw-font-medium tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-text-zinc-500'>
        <MapPinX strokeWidth={1.6} />
        No Map Available
      </p>
    </div>
  );
});

EmptyMapView.displayName = 'EmptyMapView';
